query TopSessionComponents($runId: ConditionID!) {
	wfa_top_critical_components(
		run_id_eq: $runId
		sort: { order: Descending, fields: critical_percentage }
		limit: 10
	) {
		elements__component_id
		critical_percentage
	}
}
